import { cleanObj } from "./utils";
import type { PortableTextBlock } from "@portabletext/types";

const url = "/api/v1/medical_experts";

export type MedicalExpert = {
  _id: string;
  aboutMe: PortableTextBlock[];
  alt: string;
  credentials: string;
  descriptionShort: string;
  educationLong: PortableTextBlock[];
  educationShort: string;
  expertiseLong: PortableTextBlock[];
  expertiseShort: string;
  hasBioPage: boolean;
  highlights: PortableTextBlock[];
  imgSrc: string;
  name: string;
  metaDescription: string;
  metaTitle: string;
  quote: string;
  slug: string;
};

export interface MedicalExpertsShowParams {
  draft?: boolean;
  slug: string;
}

export const medicalExpertsShowQuery = ({
  slug,
  ...params
}: MedicalExpertsShowParams) => ({
  url: `${url}/${slug}`,
  method: "GET",
  params: cleanObj(params),
});
